import { createReducer } from '@reduxjs/toolkit';

import patchWarehouse from '../../../thunks/coilovers/warehouse/patchWarehouse';
import { clearPatchWarehouseParts } from '../../../actions/coilovers/warehouse/patchWarehouse';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const patchWarehouseReducer = createReducer(initialState, {
  [patchWarehouse.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [patchWarehouse.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [patchWarehouse.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearPatchWarehouseParts]: () => initialState
});

export default patchWarehouseReducer;
